// Generated by ReScript, PLEASE EDIT WITH CARE


function importCss(param) {
  return (require(`PretendAsCallerAssets/styles/components/_all.scss`));
}

function getImage(name) {
  var requireImage = (function(name){
        return require(`PretendAsCallerAssets/images/${name}`).default
      });
  return requireImage(name);
}

export {
  importCss ,
  getImage ,
  
}
/* No side effect */
